import type { PerformanceTimePeriodName } from './generated/gql-enums';

export const PERFORMANCE_TIME_PERIOD_ALL_TIME = 'all_time' satisfies PerformanceTimePeriodName;
export const PERFORMANCE_TIME_PERIOD_LAST_QUARTER = 'last_quarter' satisfies PerformanceTimePeriodName;
export const PERFORMANCE_TIME_PERIOD_PAST_MONTH = 'past_month' satisfies PerformanceTimePeriodName;
export const PERFORMANCE_TIME_PERIOD_PAST_THREE_MONTHS = 'past_three_months' satisfies PerformanceTimePeriodName;
export const PERFORMANCE_TIME_PERIOD_PAST_YEAR = 'past_year' satisfies PerformanceTimePeriodName;
export const PERFORMANCE_TIME_PERIOD_YEAR_TO_DATE = 'year_to_date' satisfies PerformanceTimePeriodName;
